<template>
  <div id="hContent">
    <div id="hpc">
      <div id="hFirst" ref="homePage">
        <el-carousel id="hCarousel" :interval="5000" arrow="always">
          <el-carousel-item v-for="item in tableData" :key="item.images" style="width: 100%;height: 100%;">
            <img style="width: 100%;height: 100%;" :src="item.images">
          </el-carousel-item>
        </el-carousel>
      </div>
      <div id="hSecond">
        <div id="VR_tbgd" style="display: none;">
          <div style="">
            <div style="font-size: 2em;font-weight: 600;color: rgb(255,255,255);line-height: 80px;">展</div>
            <div @click="JupUrlVRTB" style="width: 40px;font-size: 1.5em;font-weight: 600;color: rgb(149,111,23);line-height: 35px;margin-left: 20px;">唐蕃古道虚拟展馆</div>
          </div>
        </div>
        <div id="sConone">
          <div id="cPaddcon">
            <router-link tag="div" :to="{path:'/Social/forum'}" id="cP_left">
              <div id="cP_img">
                <img style="width: 100%;height: 100%;" src="../assets/img/homepage/zx.jpg">
              </div>
              <div id="cP_title">社教活动</div>
            </router-link>
            <div id="cP_right">
              <div id="cP_top">
                <div>青海省博物馆免费开放须知</div>
                <div>1、周二至周日9:00-17:00（16:30停止入场）。</div>
                <div>2、逢周一闭馆（如遇特殊节日需开放时，将会另行发送开馆通知）。</div>
              </div>
              <div id="cP_bottom">
                <router-link tag="div" :to="{path:'/Wenchuang'}" id="btm_left">
                  <div id="btm_img">
                    <img src="../assets/img/homepage/wc.jpg">
                  </div>
                  <div id="btm_title">文创展示</div>
                </router-link>
                <router-link tag="div" :to="{path:'/exhibitioninfo/exchange'}" id="btm_right">
                  <div id="rgt_img">
                    <img src="../assets/img/homepage/zl.jpg">
                  </div>
                  <div id="rgt_title">展览展示</div>
                </router-link>
              </div>
            </div>
            <div style="clear: both;"></div>
          </div>
        </div>
        <div id="sContow">
          <div id="cMargcon">
            <div id="cM_left">
              <div id="Tow_left">
                <ul id="da-thumbs" class="da-thumbs">
                  <li id="da-thumbs_nav1" style="background: #00A0E9;">
                    <router-link tag="a" :to="{path:'/collectionDetials/collectionDetials', query:{collectionid:2868,t:encodeURIComponent('乾隆开光瓷尊')}}">
                      <img src="../assets/img/homepage/bcimg/5.jpg" />
                      <div>
                        <span>乾隆开光瓷尊</span>
                        <span style="text-align: left;line-height: 25px;">瓷质，直颈，鼓腹，高足，肩饰铺首环。通体施黑色底釉上挂蓝斑釉，采用浅浮雕描金技法，颈部饰蕉叶纹，腹部饰蛟龙...</span>
                      </div>
                    </router-link>
                  </li>
                  <li id="da-thumbs_nav2" style="background: #008200;">
                    <router-link tag="a" :to="{path:'/collectionDetials/collectionDetials', query:{collectionid:2869,t:encodeURIComponent('乾隆粉彩人物瓷瓶')}}">
                      <img src="../assets/img/homepage/bcimg/4.jpg" />
                      <div>
                        <span>乾隆粉彩人物瓷瓶</span>
                        <span style="text-align: left;line-height: 25px;">瓷质，侈口，长颈，圆腹，圈足。通体施白底釉，口沿外一周绘红彩八蝠及黒彩璎珞纹，腹部用五彩绘寿星、琴棋、松树...</span>
                      </div>
                    </router-link>
                  </li>
                </ul>
              </div>
              <div id="Tow_right">
                <div id="zp_title">珍品展示</div>
                <div id="zp_counts">共&nbsp;<span>{{counts}}</span>&nbsp;件</div>
                <router-link id="zp_coll" tag="div" :to="{path:'/Collection'}">查看更多<span><i class="el-icon-d-arrow-right"></i></span></router-link>
              </div>
            </div>
            <div id="cM_right">
              <div id="cM_cons">
                <div id="cM_title">活动预约</div>
                <div id="cM_content">
                  <div id="hdlist" v-for="(item,index) in tableDataActivitystr" :key="index">
                    <router-link tag="div" :to="{path:'/about/sjactivity/activityDetials', query:{id:item.id}}" id="hd_left">{{item.title}}</router-link>
                    <div id="hd_right">{{item.times}}</div>
                    <div style="clear: both;"></div>
                  </div>
                  <router-link tag="div" :to="{path:'/about/sjactivity/activity'}" id="gendhd">更多<span><i class="el-icon-d-arrow-right"></i></span></router-link>
                </div>
              </div>
              <div id="fct">
                <img src="../assets/img/homepage/ft.png">
              </div>
            </div>
            <div style="clear: both;"></div>
          </div>
        </div>
        <div id="sConthree">
          <div id="cThreecon">
            <div id="cT_left">
              <div id="cT_title">资讯要闻</div>
              <div id="cT_cons">
                <div id="zxxw" v-for="(item,index) in arrSubstr" :key="index">
                  <router-link tag="div" :to="{path:'/informationsDetials/newsDetials', query:{id:item.id}}" style="float: left; margin-left: 10px;">{{item.title}}</router-link>
                  <div style="float: right;margin-right: 20px;">{{item.time}}</div>
                </div>
                <div style="clear: both;"></div>
                <router-link tag="div" :to="{path:'/informations/qbdynamic'}" id="gend">更多<span><i class="el-icon-d-arrow-right"></i></span></router-link>
              </div>
              <div id="cT_fc">
                <img src="../assets/img/homepage/fc.png">
              </div>
            </div>
            <div id="cT_right">
              <div id="cT_img">
                <img src="../assets/img/homepage/xsyj.png">
              </div>
              <div id="cT_Xs">
                <div id="xS_title">学术研究</div>
                <div id="xS_cons">
                  <div id="x_list" v-for="(item,index) in arrFuritData" :key="index">
                    <router-link tag="div" :to="{path:'/academic/learningDetials', query:{id:item.id}}" id="xS_c">{{item.title}}</router-link>
                  </div>
                </div>
                <router-link tag="div" :to="{path:'/academic'}" id="gendxs">更多<span><i class="el-icon-d-arrow-right"></i></span></router-link>
              </div>
            </div>
            <div style="clear: both;"></div>
          </div>
        </div>
      </div>
    </div>
    <div id="hmobile">
      <div id="mhFirst" ref="homePage">
        <el-carousel :interval="5000" arrow="always">
          <el-carousel-item v-for="item in tableData" :key="item.images" style="width: 100%;height: 100%;">
            <img style="width: 100%;height: 100%;" :src="item.images">
          </el-carousel-item>
        </el-carousel>
      </div>
      <div style="margin-top: 10px;height: 153px;">
        <div style="margin: auto 10px;height: 153px;">
          <div style="float: left;width: 25%;height: 153px;position: relative;text-align: left;padding-left: 1%;padding-right: 1%;background: #fcf5e3;">
            <div style="font-size: 8px;color: #956f17;">开放须知：</div>
            <div style="font-size: 8px;">1、每周二至周日免费开放</div>
            <div style="font-size: 8px;">2、参观时间：9:00-17:00(16:30停止入场)</div>
            <div style="font-size: 8px;">3、周一闭馆，节假日，其他重要活动等特殊情况将提前公告开放时间。</div>
            <div style="font-size: 8px;">4、温馨提示：参观请携带有效证件</div>
          </div>
          <router-link tag="div" :to="{path:'/Wenchuang'}" style="float: left;width: 35%;height: 153px;position: relative;margin-left: 1.3%;">
            <img style="width: 100%;height: 100%;" src="../assets/img/homepage/wc.jpg">
            <div style="position: absolute;bottom: 0;background: rgba(149,111,23,0.5);color: #ffffff;padding: 5px;">文创展示</div>
          </router-link>
          <router-link tag="div" :to="{path:'/exhibitioninfo/exchange'}" style="float: left;width: 35%;height: 153px;position: relative;margin-left: 1.3%;">
            <img style="width: 100%;height: 100%;" src="../assets/img/homepage/zl.jpg">
            <div style="position: absolute;bottom: 0;background: rgba(149,111,23,0.5);color: #ffffff;padding: 5px;">展览展示</div>
          </router-link>
        </div>
        <div style="clear: both;"></div>
      </div>
      <div style="margin-top: 1.3%"></div>
      <div style="height: 153px;">
        <div style="margin: auto 10px;height: 150px;">
          <div style="float: left;width: 40%;background: #956f17;height: 100%;">
            <div style="line-height: 40px;color: #ffffff;">珍品展示</div>
            <div style="line-height: 55px;color: #ffffff;">共&nbsp;<span style="color: #FF4500;">{{counts}}</span>&nbsp;件</div>
            <router-link id="zp_coll" style="color: #ffffff;line-height: 55px;" tag="div" :to="{path:'/Collection'}">查看更多<span><i
                  class="el-icon-d-arrow-right"></i></span></router-link>
          </div>
          <div style="float: right;width: 60%;height: 100%;">
            <div style="float: left;height: 100%;width: 50%;position: relative;">
              <router-link tag="a" :to="{path:'/collectionDetials/collectionDetials', query:{collectionid:167}}">
                <img style="width: 100%;height: 100%;" src="../assets/img/homepage/bcimg/5.jpg" />
              </router-link>
            </div>
            <div style="float: left;height: 100%;width: 50%;position: relative;">
              <router-link tag="a" :to="{path:'/collectionDetials/collectionDetials', query:{collectionid:168}}">
                <img style="width: 100%;height: 100%;" src="../assets/img/homepage/bcimg/4.jpg" />
              </router-link>
            </div>
          </div>
          <div style="clear: both;"></div>
        </div>
      </div>
      <div style="margin-top: 1.3%;height: 153px;">
        <div style="margin: auto 10px;height: 153px;">
          <router-link tag="div" :to="{path:'/Social/forum'}" style="float: left;width: 35%;height: 153px;position: relative;">
            <img style="width: 100%;height: 100%;" src="../assets/img/homepage/zx.jpg">
            <div style="position: absolute;bottom: 0;background: rgba(149,111,23,0.5);color: #ffffff;padding: 5px;">社教活动</div>
          </router-link>
          <router-link tag="div" :to="{path:'/informations/qbdynamic'}" style="float: left;width: 35%;height: 153px;position: relative;margin-left: 1.3%;">
            <img style="width: 100%;height: 100%;" src="../assets/img/homepage/xsyj.png">
            <div style="position: absolute;bottom: 0;background: rgba(149,111,23,0.5);color: #ffffff;padding: 5px;">资讯要闻</div>
          </router-link>
          <div style="float: left;width: 27%;height: 153px;position: relative;text-align: left;margin-left: 1.3%;"
            @click="JupUrlVR">
            <img style="width: 100%;height: 100%;" src="../assets/img/homepage/vr.jpg">
            <div style="position: absolute;bottom: 0;background: rgba(149,111,23,0.5);color: #ffffff;padding: 5px;">虚拟展馆</div>
          </div>
        </div>
        <div style="clear: both;"></div>
      </div>
      <div style="margin-top: 1.3%;"></div>
      <div style="height: 50px;background: #ebf7ff;margin: auto 10px;">
        <div style="width: 140px;height: 50px;float: left;">
          <div style="float: left;line-height: 50px;background: #eeffe9; width: 100px;color: #956f17;">活动预约</div>
          <div style="float: left;width: 40px;height: 40px;margin-top: 5px;">
            <img style="width: 100%;height: 100%;" src="../assets/img/lb.png" />
          </div>
        </div>
        <div style="float: left;line-height: 50px;margin-left: 10px;" v-for="(item,index) in tableDatamActivitystr"
          :key="index">
          <div v-if="item.stusts===1">
            <div>{{item.title}}</div>
          </div>
          <div v-if="item.stusts===2">
            <router-link tag="div" :to="{path:'/about/sjactivity/activityDetials', query:{id:item.id}}" id="hd_left">{{item.title}}</router-link>
          </div>
        </div>
        <div style="clear: both;"></div>
      </div>
      <div style="height: 20px;"></div>
    </div>
    <div class="notices clear" v-if="isShow">
      <div style="width: 200px;height: 80px;border-radius: 10px; cursor: pointer;opacity: 0.8; color: rgb(149,111,23);">
        <div style="text-align: right;padding-right: 5px;height: 10px;z-index: 999999;"><i class="el-icon-close" style="cursor: pointer;"
            @click="closeShow()"></i></div>
        <router-link tag="div" v-if="isShow" :to="{path:'/informationsDetials/closure', query:{id:tableDataclosure.id}}">
          <div style="line-height: 30px;">青海省博物馆</div>
          <div style="line-height: 30px;">{{tableDataclosure.title}}</div>
        </router-link>

      </div>
      <div class="shadow"></div>
    </div>
  </div>
</template>

<script>
  import {
    jquery
  } from '@/assets/js/jquery.js'
  import {
    hoverdir
  } from '@/assets/js/hoverdir.js'
  import moment from 'moment'
  export default {
    data() {
      return {
        clientHeight: '',
        tableData: [],
        tableDataNews: [],
        tableDataCollection: [],
        loading: false,
        counts: 0,
        arrData: [],
        arrSubstr: [],
        tableDataActivity: [],
        tableDataActivitystr: [],
        arrActivityData: [],
        tableDataFurit: [],
        arrFuritData: [],
        tableDatmaActivity: [],
        tableDatamActivitystr: [],
        arrmActivityData: [],
        tableDataclosure: [],
        isShow: false,
        pageTotal: [],
        currentPage: 1,
        pageSize: 10,
        pageNum: 1
      }
    },
    mounted() {
      if (this.isMobile()) {
        $("#hmobile").css("display", "block");
        this.updated();
        this.search();
        this.searchCollection();
        this.searchNews();
        this.searchmActivity();
        this.searchFurit();
        this.searchclosure();
        if (location.href.indexOf("#reloaded") == -1) {
          location.href = location.href + "#reloaded";
          location.reload();
        };
      } else {
        //  		document.getElementById("hpc").style.display = "block";
        //  		document.getElementById("hmobile").style.display = "none";
        $("#hpc").css("display", "block");
        this.updated();
        this.clientHeight = `${document.documentElement.clientHeight}` //document.body.clientWidth;
        window.onresize = function temp() {
          this.clientHeight = `${document.documentElement.clientHeight}`;
        };
        this.search();
        this.searchCollection();
        this.searchNews();
        this.searchActivity();
        this.searchFurit();
        this.searchclosure();
        $('#da-thumbs > li').each(
          function() {
            $(this).hoverdir({
              hoverDelay: 75
            })
          }
        );
        let SecondWidth = document.body.clientWidth;
        let sWidth = SecondWidth * 0.9;
      }
    },
    watch: {
      clientHeight: function() {
        this.changeFixed(this.clientHeight)
      }
    },
    methods: {
      updated() {
        window.scroll(0, 0);
      },
      isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
        return flag;
      },
      JupUrlVRTB: function() {
        window.open("http://huitailang.mzgtuan.com/project/26/")
      },
      closeShow: function() {
        this.isShow = false;
      },
      changeFixed(clientHeight) { //动态修改样式
        let SecondWidth = document.body.clientWidth;
        let wHeight = SecondWidth / (1980 / 230);
        this.$refs.homePage.style.height = (clientHeight - wHeight) + 'px';
        document.getElementById('hCarousel').style.height = (clientHeight - wHeight) + 'px';
      },
      JupUrlVR: function() {
        window.open("http://www.expoon.com/28160/panorama?from=singlemessage&isappinstalled=0")
      },
      // 首页轮播图
      search: function() {
        let that = this;
        let url = this.HOST + '/api/v1/carousel/carouselAll?pageNumber=' + this.pageNum + '&pageSize=' + this.pageSize +
          ''
        that.loading = true;
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          that.tableData = cData.data.list;
        }).catch(function(error) {
          console.log(err);
        })
      },

      //新闻
      searchNews: function() {
        let that = this;
        let url = this.HOST + '/api/v1/news-wb/dynamicAll?pageNumber=' + this.pageNum + '&pageSize=5';
        that.loading = true;
        this.$axios.get(url).then(function(result) {
          let cData = result.data.data.list;
          for (let i = 0; i < cData.length; i++) {
            if (cData[i].radio == "201") {
              that.tableDataNews.push(cData[i]);
            }
          };
          let len = that.tableDataNews.length;
          that.arrData = that.tableDataNews.slice(0, 5);
          for (let k = 0; k < that.arrData.length; k++) {
            let str = {};
            str.id = that.arrData[k].id;
            str.time = that.arrData[k].starttime;
            if (that.arrData[k].title.length > 12) {
              str.title = (that.arrData[k].title).substring(0, 12) + "...";
            } else {
              str.title = that.arrData[k].title;
            };
            that.arrSubstr.push(str);
          };
        }).catch(function(error) {
          console.log(err);
        })
      },

      //藏品
      searchCollection: function() {
        let that = this;
        let url = this.HOST + '/api/v1/collection/collectionAll?pageNumber=' + this.pageNum + '&pageSize=10';
        this.loading = true;
        this.$axios.get(url).then(function(result) {
          let cData = result.data.data.list;
          that.tableDataCollection = cData;
          that.counts = result.data.data.total;
        }).catch(function(error) {
          console.log(err);
        })
      },
      //活动
      searchActivity: function() {
        let that = this;
        let url = this.HOST + '/api/v1/activity/activity?pageNumber=' + this.pageNum + '&pageSize=5';
        this.loading = true;
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          that.tableDataActivity = cData.data.list;
          let len = that.tableDataActivity.length;
          that.arrActivityData = that.tableDataActivity.slice(0, 5);
          for (let i = 0; i < that.arrActivityData.length; i++) {
            let timestampEnd = parseInt(that.arrActivityData[i].activityendtime);
            let timestampstart = parseInt(that.arrActivityData[i].activitytime);
            that.arrActivityData[i].endtime = moment(timestampEnd).format("YYYY-MM-DD");
            that.arrActivityData[i].starttime = moment(timestampstart).format("YYYY-MM-DD");
            let str = {};
            str.id = that.arrActivityData[i].id;
            str.times = that.arrActivityData[i].starttime;
            if (that.arrActivityData[i].title.length > 12) {
              str.title = (that.tableDataActivity[i].title).substring(0, 12) + "...";
            } else {
              str.title = that.tableDataActivity[i].title
            };
            that.tableDataActivitystr.push(str);
          }
        }).catch(function(error) {
          console.log(err);
        })
      },
      searchmActivity: function() {
        let that = this;
        let url = this.HOST + '/api/v1/activity/activity?pageNumber=' + this.pageNum + '&pageSize=5';
        that.loading = true;
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          that.tableDatamActivity = cData.data.list;
          let len = that.tableDatamActivity.length;
          that.tableDatamActivity = that.tableDatamActivity.slice(0, 1);
          for (let i = 0; i < that.tableDatamActivity.length; i++) {
            let timestampEnd = parseInt(that.tableDatamActivity[i].activityendtime);
            let timestampstart = parseInt(that.tableDatamActivity[i].activitytime);
            that.tableDatamActivity[i].endtime = moment(timestampEnd).format("YYYY-MM-DD");
            that.tableDatamActivity[i].starttime = moment(timestampstart).format("YYYY-MM-DD");
            let newtime = (new Date()).toLocaleDateString();
            newtime = newtime.replace(/\//g, '-');
            let nowdate = moment(newtime, 'YYYY-MM-DD HH:mm').valueOf();
            let str = {};
            str.id = that.tableDatamActivity[i].id;
            str.times = that.tableDatamActivity[i].starttime;
            if (nowdate > timestampEnd) {
              str.title = "暂无活动";
              str.stusts = 1;
            } else {
              if (that.tableDatamActivity[i].title.length > 10) {
                str.title = (that.tableDatamActivity[i].title).substring(0, 10) + "...";
              } else {
                str.title = that.tableDatamActivity[i].title
              };
              str.stusts = 2;
            }
            that.tableDatamActivitystr.push(str);
          }
        }).catch(function(error) {
          console.log(err);
        })
      },
      //学术研究
      searchFurit: function() {
        let that = this;
        let url = this.HOST + '/api/v1/academic/academic?pageNumber=' + this.pageNum + '&pageSize=6'
        that.loading = true;
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          that.tableDataFurit = cData.data.list;
          for (let k = 0; k < 6; k++) {
            let str = {};
            str.id = that.tableDataFurit[k].id;
            str.num = that.tableDataFurit[k].num;
            str.radio = that.tableDataFurit[k].radio;
            str.starttime = that.tableDataFurit[k].starttime;
            if (that.tableDataFurit[k].title.length > 13) {
              str.title = (that.tableDataFurit[k].title).substring(0, 13) + "...";
            } else {
              str.title = that.tableDataFurit[k].title;
            };
            that.arrFuritData.push(str);
          }
        }).catch(function(error) {
          console.log(err);
        })
      },
      searchclosure: function() {
        let that = this;
        let url = this.HOST + '/api/v1/closure/closureAll?pageNumber=' + this.pageNum + '&pageSize=1'
        that.loading = true;
        this.$axios.get(url).then(function(result) {
          let cData = result.data.data.list;
          var date = new Date();
          var seperator1 = "-";
          var year = date.getFullYear();
          var month = date.getMonth() + 1;
          var strDate = date.getDate();
          if (month >= 1 && month <= 9) {
            month = "0" + month;
          }
          if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
          }
          var currentdate = year + seperator1 + month + seperator1 + strDate;

          let etime = moment(currentdate, 'YYYY-MM-DD').valueOf();
          for (let i = 0; i < cData.length; i++) {
            if (parseInt(cData[i].endtime) >= parseInt(etime)) {
              that.tableDataclosure = cData[i];
              that.isShow = true;
            } else {
              that.isShow = false;
            }
          }
        }).catch(function(error) {
          console.log(err);
        })
      }
    }
  }
</script>

<style scoped>
  #hmobile {
    width: 100%;
    display: none;
  }

  #mhFirst {
    height: 150px;
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }

  .el-carousel {
    height: 150px;
  }

  /*pc*/
  #hpc {
    display: none;
  }

  #hCarousel {
    width: 100%;
  }

  #VR_tbgd {
    position: absolute;
    right: -80px;
    z-index: 99;
  }

  #VR_tbgd>div {
    cursor: pointer;
    width: 80px;
    height: 80px;
    background: rgba(149, 111, 23, 0.6);
    border-radius: 100px;
    text-align: center;
    overflow: hidden;
  }

  #VR_tbgd>div:hover {
    height: 400px;
  }

  #hContent {
    background-image: url(../assets/img/homepage/bgk.png);
    min-width: 100%;
    height: 100%;
    background-size: 100%;
    background-attachment: fixed;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }

  #rgt_title:hover,
  #cP_title:hover,
  #btm_title:hover {
    color: #FF5500;
  }

  @media screen and (min-width:1200px) and (max-width:1440px) {
    #hSecond {
      width: 1152px;
      margin: 0 auto;
      position: relative;
      margin-top: 24px;
    }

    #sConone {
      width: 1152px;
      height: 470px;
      background: rgb(252, 245, 227);
      position: relative;
    }

    #sContow {
      width: 1152px;
      height: 407px;
      background: rgb(235, 247, 255);
      position: relative;
      margin-top: 25px;
    }

    #sConthree {
      width: 1152px;
      height: 407px;
      background: rgb(238, 255, 233);
      position: relative;
      margin-top: 25px;
      margin-bottom: 25px;
    }

    #cThreecon {
      width: 995px;
      height: 350px;
      margin: 0 auto;
    }

    #cT_left {
      float: left;
      width: 365px;
      height: 300px;
      margin-top: 50px;
    }

    #cT_right {
      float: left;
      width: 605px;
      height: 300px;
      margin-left: 25px;
      margin-top: 50px;
      box-shadow: 3px 3px 20px rgba(16, 99, 14, 0.75);
    }

    #cT_title {
      width: 100%;
      height: 100px;
      line-height: 100px;
      font-size: 20px;
    }

    #cT_cons {
      width: 100%;
      height: 190px;
      background: #ffffff;
      box-shadow: 3px 3px 20px rgba(16, 99, 14, 0.75);
      background-image: url(../assets/img/homepage/bcimg/zxyw.jpg);
      background-size: 100%;
      position: relative;
    }

    #cT_img {
      float: left;
      width: 295px;
      height: 300px;
      overflow: hidden;
      cursor: pointer;
    }

    #cT_Xs {
      float: left;
      width: 310px;
      height: 300px;
      position: relative;
      background-image: url(../assets/img/homepage/bcimg/shj.jpg);
      background-size: 100%;
    }

    #cT_img>img {
      width: 100%;
      height: 100%;
      transform: scale3d(1, 1, 1);
      transition: opacity 0.35s ease 0s, transform 0.35s ease 0s;
    }

    #cT_img>img:hover {
      transform: scale(1.2);
      -webkit-transform: scale(1.2);
      height: 100%;
      transition: all 1s cubic-bezier(0, 1, 1, 1) 0s;
      -webkit-transition: all 1s cubic-bezier(0, 1, 1, 1) 0s;
    }

    #cMargcon {
      width: 995px;
      height: 350px;
      margin: 0 auto;
    }

    #cPaddcon {
      width: 995px;
      height: 450px;
      margin: 0 auto;
    }

    #cP_left {
      float: left;
      width: 389px;
      height: 389px;
      margin-top: 37.5px;
      position: relative;
    }

    #cP_img {
      width: 389px;
      height: 389px;
      margin: 0;
      padding: 0;
      overflow: hidden;
      cursor: pointer;
    }

    #cP_img>img {
      width: 100%;
      height: 100%;
      transform: scale3d(1, 1, 1);
      transition: opacity 0.35s ease 0s, transform 0.35s ease 0s;
    }

    #cP_img>img:hover {
      transform: scale(1.2);
      -webkit-transform: scale(1.2);
      height: 100%;
      transition: all 1s cubic-bezier(0, 1, 1, 1) 0s;
      -webkit-transition: all 1s cubic-bezier(0, 1, 1, 1) 0s;
    }

    #cP_title {
      position: absolute;
      top: 90%;
      right: 0;
      width: 240px;
      height: 60px;
      font-size: 20px;
      line-height: 60px;
      box-shadow: 3px 3px 20px rgba(188, 123, 8, 0.5);
      cursor: pointer;
      background-image: url(../assets/img/homepage/bcimg/6.jpg);
      background-size: 100%;
    }

    #cP_right {
      float: left;
      width: 581px;
      height: 470px;
      margin-left: 25px;
      margin-top: 37.5px;
    }

    #cP_top {
      width: 581px;
      height: 100px;
      text-align: left;
    }

    #cP_top>div:nth-child(1) {
      font-size: 18px;
      line-height: 30px;
    }

    #cP_top>div:nth-child(2),
    #cP_top>div:nth-child(3) {
      font-size: 15px;
      line-height: 25px;
    }

    #cP_bottom {
      width: 581px;
      height: 289px;
    }

    #btm_left {
      float: left;
      width: 200px;
      height: 100%;
      position: relative;
    }

    #btm_img {
      width: 200px;
      height: 250px;
      cursor: pointer;
      overflow: hidden;
    }

    #btm_img>img {
      width: 100%;
      height: 100%;
      transform: scale3d(1, 1, 1);
      transition: opacity 0.35s ease 0s, transform 0.35s ease 0s;
    }

    #btm_img>img:hover {
      transform: scale(1.2);
      -webkit-transform: scale(1.2);
      height: 100%;
      transition: all 1s cubic-bezier(0, 1, 1, 1) 0s;
      -webkit-transition: all 1s cubic-bezier(0, 1, 1, 1) 0s;
    }

    #btm_title {
      width: 200px;
      height: 60px;
      font-size: 20px;
      line-height: 60px;
      background: #ffffff;
      box-shadow: 3px 3px 20px rgba(188, 123, 8, 0.5);
      cursor: pointer;
      background-image: url(../assets/img/homepage/bcimg/6.jpg);
      background-size: 100%;
    }

    #btm_right {
      float: left;
      width: 356px;
      height: 289px;
      margin-left: 25px;
      position: relative;
    }

    #rgt_img {
      width: 356px;
      height: 100%;
      overflow: hidden;
      cursor: pointer;
    }

    #rgt_img>img {
      width: 100%;
      height: 100%;
      transform: scale3d(1, 1, 1);
      transition: opacity 0.35s ease 0s, transform 0.35s ease 0s;
    }

    #rgt_img>img:hover {
      transform: scale(1.2);
      -webkit-transform: scale(1.2);
      height: 100%;
      transition: all 1s cubic-bezier(0, 1, 1, 1) 0s;
      -webkit-transition: all 1s cubic-bezier(0, 1, 1, 1) 0s;
    }

    #rgt_title {
      position: absolute;
      top: 86%;
      left: 0;
      width: 80%;
      height: 60px;
      font-size: 20px;
      line-height: 60px;
      background: #ffffff;
      box-shadow: 3px 3px 20px rgba(188, 123, 8, 0.5);
      cursor: pointer;
      background-image: url(../assets/img/homepage/bcimg/6.jpg);
      background-size: 100%;
    }

    #cM_left {
      float: left;
      width: 610px;
      height: 300px;
      margin-top: 50px;
      box-shadow: 3px 3px 20px rgba(15, 106, 130, 0.75);
    }

    #cM_right {
      float: left;
      width: 360px;
      margin-left: 25px;
      height: 300px;
      margin-top: 50px;
      background: #ffffff;
      box-shadow: 3px 3px 20px rgba(15, 106, 130, 0.75);
      background-image: url(../assets/img/homepage/bcimg/hdyy.jpg);
      background-size: 100%;
    }

    #cM_cons {
      position: relative;
      height: 300px;
    }

    #fct {
      position: absolute;
      top: 52%;
      left: 72%;
      width: 250px;
      height: 150px;
    }

    #fct>img {
      width: 100%;
      height: 100%;
    }

    #cT_fc {
      position: absolute;
      top: 60%;
      width: 150px;
      height: 150px;
    }

    #cT_fc>img {
      width: 100%;
      height: 100%;
    }

    #Tow_left {
      float: left;
      width: 410px;
      height: 300px;
      position: relative;
    }

    #Tow_right {
      float: left;
      width: 200px;
      height: 300px;
      position: relative;
      background: #ffffff;
      background-image: url(../assets/img/homepage/bcimg/gczp.jpg);
      background-size: 100%;
    }

    #Tow_right>span {
      font-size: 20px;
    }

    .da-thumbs {
      list-style: none;
      position: relative;
      padding: 0;
      margin: 0;
    }

    .da-thumbs li {
      background: #fff;
      position: relative;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }

    .da-thumbs li a,
    .da-thumbs li a img {
      display: block;
      position: relative;
      width: 100%;
      height: 100%;
    }

    .da-thumbs li a {
      overflow: hidden;
    }

    .da-thumbs li a div {
      position: absolute;
      background: #333;
      background: rgba(75, 75, 75, 0.7);
      width: 100%;
      height: 100%;
    }

    .da-thumbs li a div span:nth-child(1) {
      display: block;
      padding: 10px 0;
      margin: 40px 20px 20px 20px;
      text-transform: uppercase;
      font-weight: normal;
      color: rgba(255, 255, 255, 0.9);
      text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
      border-bottom: 1px solid rgba(255, 255, 255, 0.5);
      /*box-shadow: 0 1px 0 rgba(0,0,0,0.1), 0 -10px 0 rgba(255,255,255,0.3);*/
    }

    .da-thumbs li a div span:nth-child(2) {
      display: block;
      padding: 10px 0;
      margin: 0 20px;
      text-transform: uppercase;
      font-weight: normal;
      color: rgba(255, 255, 255, 0.9);
      text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
      /*border-bottom: 1px solid rgba(255,255,255,0.5);*/
      /*box-shadow: 0 1px 0 rgba(0,0,0,0.1), 0 -10px 0 rgba(255,255,255,0.3);*/
    }

    #da-thumbs_nav1 {
      float: left;
      width: 205px;
      height: 300px;
    }

    #da-thumbs_nav2 {
      float: left;
      width: 205px;
      height: 300px;
    }

    #cM_title {
      font-size: 20px;
      height: 60px;
      line-height: 60px;
    }

    #zp_title {
      font-size: 20px;
      height: 100px;
      line-height: 1-0px;
    }

    #gend {
      position: absolute;
      line-height: 40px;
      text-align: right;
      margin-right: 20px;
      color: #FF5500;
      cursor: pointer;
      right: 0%;
      top: 80%;
    }

    #zxxw {
      text-align: left;
      line-height: 30px;
      cursor: pointer;
      position: relative;
      z-index: 999;
    }

    #zxxw:hover {
      color: #FF5500;
    }

    #hd_left {
      float: left;
      margin-left: 20px;
    }

    #hd_right {
      float: right;
      margin-right: 20px;
    }

    #hdlist {
      line-height: 30px;
      cursor: pointer;
    }

    #hdlist:hover {
      color: #FF5500;
    }

    #gendhd {
      position: absolute;
      top: 90%;
      right: 0;
      cursor: pointer;
      margin-right: 20px;
      color: #FF5500;
      z-index: 99999;
    }

    #xS_title {
      font-size: 20px;
      height: 60px;
      line-height: 60px;
    }

    #x_list {
      line-height: 30px;
      cursor: pointer;
      text-align: left;
      padding-left: 20px;
      padding-right: 20px;
    }

    #x_list:hover {
      color: #FF5500;
    }

    #gendxs {
      position: absolute;
      top: 90%;
      right: 0;
      cursor: pointer;
      margin-right: 20px;
      color: #FF5500;
      z-index: 99999;
    }

    #zp_counts {
      font-size: 20px;
      font-weight: 500;
      line-height: 100px;
    }

    #zp_counts>span {
      color: #FF5500;
    }

    #zp_coll {
      font-size: 20px;
      font-weight: 500;
      line-height: 100px;
      cursor: pointer;
      color: #FF5500;
    }
  }

  #hSecond {
    width: 1152px;
    margin: 0 auto;
    position: relative;
    margin-top: 24px;
  }

  #sConone {
    width: 1152px;
    height: 470px;
    background: rgb(252, 245, 227);
    position: relative;
  }

  #sContow {
    width: 1152px;
    height: 407px;
    background: rgb(235, 247, 255);
    position: relative;
    margin-top: 25px;
  }

  #sConthree {
    width: 1152px;
    height: 407px;
    background: rgb(238, 255, 233);
    position: relative;
    margin-top: 25px;
    margin-bottom: 25px;
  }

  #cThreecon {
    width: 995px;
    height: 350px;
    margin: 0 auto;
  }

  #cT_left {
    float: left;
    width: 365px;
    height: 300px;
    margin-top: 50px;
  }

  #cT_right {
    float: left;
    width: 605px;
    height: 300px;
    margin-left: 25px;
    margin-top: 50px;
    box-shadow: 3px 3px 20px rgba(16, 99, 14, 0.75);
  }

  #cT_title {
    width: 100%;
    height: 100px;
    line-height: 100px;
    font-size: 20px;
  }

  #cT_cons {
    width: 100%;
    height: 190px;
    background: #ffffff;
    box-shadow: 3px 3px 20px rgba(16, 99, 14, 0.75);
    position: relative;
    background-image: url(../assets/img/homepage/bcimg/zxyw.jpg);
    background-size: 100%;
  }

  #cT_img {
    float: left;
    width: 295px;
    height: 300px;
    overflow: hidden;
    cursor: pointer;
  }

  #cT_Xs {
    float: left;
    width: 310px;
    height: 300px;
    position: relative;
    background-image: url(../assets/img/homepage/bcimg/shj.jpg);
    background-size: 100%;
  }

  #cT_img>img {
    width: 100%;
    height: 100%;
    transform: scale3d(1, 1, 1);
    transition: opacity 0.35s ease 0s, transform 0.35s ease 0s;
  }

  #cT_img>img:hover {
    transform: scale(1.2);
    -webkit-transform: scale(1.2);
    height: 100%;
    transition: all 1s cubic-bezier(0, 1, 1, 1) 0s;
    -webkit-transition: all 1s cubic-bezier(0, 1, 1, 1) 0s;
  }

  #cMargcon {
    width: 995px;
    height: 350px;
    margin: 0 auto;
  }

  #cPaddcon {
    width: 995px;
    height: 450px;
    margin: 0 auto;
  }

  #cP_left {
    float: left;
    width: 389px;
    height: 389px;
    margin-top: 37.5px;
    position: relative;
  }

  #cP_img {
    width: 389px;
    height: 389px;
    margin: 0;
    padding: 0;
    overflow: hidden;
    cursor: pointer;
  }

  #cP_img>img {
    width: 100%;
    height: 100%;
    transform: scale3d(1, 1, 1);
    transition: opacity 0.35s ease 0s, transform 0.35s ease 0s;
  }

  #cP_img>img:hover {
    transform: scale(1.2);
    -webkit-transform: scale(1.2);
    height: 100%;
    transition: all 1s cubic-bezier(0, 1, 1, 1) 0s;
    -webkit-transition: all 1s cubic-bezier(0, 1, 1, 1) 0s;
  }

  #cP_title {
    position: absolute;
    top: 90%;
    right: 0;
    width: 240px;
    height: 60px;
    font-size: 20px;
    line-height: 60px;
    background: #ffffff;
    box-shadow: 3px 3px 20px rgba(188, 123, 8, 0.5);
    cursor: pointer;
    background-image: url(../assets/img/homepage/bcimg/6.jpg);
    background-size: 100%;
  }

  #cP_right {
    float: left;
    width: 581px;
    height: 470px;
    margin-left: 25px;
    margin-top: 37.5px;
  }

  #cP_top {
    width: 581px;
    height: 100px;
    text-align: left;
  }

  #cP_top>div:nth-child(1) {
    font-size: 18px;
    line-height: 30px;
  }

  #cP_top>div:nth-child(2),
  #cP_top>div:nth-child(3) {
    font-size: 15px;
    line-height: 25px;
  }

  #cP_bottom {
    width: 581px;
    height: 289px;
  }

  #btm_left {
    float: left;
    width: 200px;
    height: 100%;
    position: relative;
  }

  #btm_img {
    width: 200px;
    height: 250px;
    cursor: pointer;
    overflow: hidden;
  }

  #btm_img>img {
    width: 100%;
    height: 100%;
    transform: scale3d(1, 1, 1);
    transition: opacity 0.35s ease 0s, transform 0.35s ease 0s;
  }

  #btm_img>img:hover {
    transform: scale(1.2);
    -webkit-transform: scale(1.2);
    height: 100%;
    transition: all 1s cubic-bezier(0, 1, 1, 1) 0s;
    -webkit-transition: all 1s cubic-bezier(0, 1, 1, 1) 0s;
  }

  #btm_title {
    width: 200px;
    height: 60px;
    font-size: 20px;
    line-height: 60px;
    background: #ffffff;
    box-shadow: 3px 3px 20px rgba(188, 123, 8, 0.5);
    cursor: pointer;
    background-image: url(../assets/img/homepage/bcimg/6.jpg);
    background-size: 100%;
  }

  #btm_right {
    float: left;
    width: 356px;
    height: 289px;
    margin-left: 25px;
    position: relative;
  }

  #rgt_img {
    width: 356px;
    height: 100%;
    overflow: hidden;
    cursor: pointer;
  }

  #rgt_img>img {
    width: 100%;
    height: 100%;
    transform: scale3d(1, 1, 1);
    transition: opacity 0.35s ease 0s, transform 0.35s ease 0s;
  }

  #rgt_img>img:hover {
    transform: scale(1.2);
    -webkit-transform: scale(1.2);
    height: 100%;
    transition: all 1s cubic-bezier(0, 1, 1, 1) 0s;
    -webkit-transition: all 1s cubic-bezier(0, 1, 1, 1) 0s;
  }

  #rgt_title {
    position: absolute;
    top: 86%;
    left: 0;
    width: 80%;
    height: 60px;
    font-size: 20px;
    line-height: 60px;
    background: #ffffff;
    box-shadow: 3px 3px 20px rgba(188, 123, 8, 0.5);
    cursor: pointer;
    background-image: url(../assets/img/homepage/bcimg/6.jpg);
    background-size: 100%;
  }

  #cM_left {
    float: left;
    width: 610px;
    height: 300px;
    margin-top: 50px;
    box-shadow: 3px 3px 20px rgba(15, 106, 130, 0.75);
  }

  #cM_right {
    float: left;
    width: 360px;
    margin-left: 25px;
    height: 300px;
    margin-top: 50px;
    box-shadow: 3px 3px 20px rgba(15, 106, 130, 0.75);
    background-image: url(../assets/img/homepage/bcimg/hdyy.jpg);
    background-size: 100%;
  }

  #cM_cons {
    position: relative;
    height: 300px;
  }

  #fct {
    position: absolute;
    top: 52%;
    left: 72%;
    width: 250px;
    height: 150px;
  }

  #fct>img {
    width: 100%;
    height: 100%;
  }

  #cT_fc {
    position: absolute;
    top: 60%;
    width: 150px;
    height: 150px;
  }

  #cT_fc>img {
    width: 100%;
    height: 100%;
  }

  #Tow_left {
    float: left;
    width: 410px;
    height: 300px;
    position: relative;
  }

  #Tow_right {
    float: left;
    width: 200px;
    height: 300px;
    position: relative;
    background: #ffffff;
    background-image: url(../assets/img/homepage/bcimg/gczp.jpg);
    background-size: 100%;
  }

  #Tow_right>span {
    font-size: 20px;
  }

  .da-thumbs {
    list-style: none;
    position: relative;
    padding: 0;
    margin: 0;
  }

  .da-thumbs li {
    background: #fff;
    position: relative;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  .da-thumbs li a,
  .da-thumbs li a img {
    display: block;
    position: relative;
    width: 100%;
    height: 100%;
  }

  .da-thumbs li a {
    overflow: hidden;
  }

  .da-thumbs li a div {
    position: absolute;
    background: #333;
    background: rgba(75, 75, 75, 0.7);
    width: 100%;
    height: 100%;
  }

  .da-thumbs li a div span:nth-child(1) {
    display: block;
    padding: 10px 0;
    margin: 40px 20px 20px 20px;
    text-transform: uppercase;
    font-weight: normal;
    color: rgba(255, 255, 255, 0.9);
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
    border-bottom: 1px solid rgba(255, 255, 255, 0.5);
    /*box-shadow: 0 1px 0 rgba(0,0,0,0.1), 0 -10px 0 rgba(255,255,255,0.3);*/
  }

  .da-thumbs li a div span:nth-child(2) {
    display: block;
    padding: 10px 0;
    margin: 0 20px;
    text-transform: uppercase;
    font-weight: normal;
    color: rgba(255, 255, 255, 0.9);
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
    /*border-bottom: 1px solid rgba(255,255,255,0.5);*/
    /*box-shadow: 0 1px 0 rgba(0,0,0,0.1), 0 -10px 0 rgba(255,255,255,0.3);*/
  }

  #da-thumbs_nav1 {
    float: left;
    width: 205px;
    height: 300px;
  }

  #da-thumbs_nav2 {
    float: left;
    width: 205px;
    height: 300px;
  }

  #cM_title {
    font-size: 20px;
    height: 60px;
    line-height: 60px;
  }

  #zp_title {
    font-size: 20px;
    height: 100px;
    line-height: 100px;
  }

  #gend {
    position: absolute;
    line-height: 40px;
    text-align: right;
    margin-right: 20px;
    color: #FF5500;
    cursor: pointer;
    right: 0;
    top: 80%;
  }

  #zxxw {
    text-align: left;
    line-height: 30px;
    cursor: pointer;
    position: relative;
    z-index: 999;
  }

  #zxxw:hover {
    color: #FF5500;
  }

  #hd_left {
    float: left;
    margin-left: 20px;
  }

  #hd_right {
    float: right;
    margin-right: 20px;
  }

  #hdlist {
    line-height: 30px;
    cursor: pointer;
  }

  #hdlist:hover {
    color: #FF5500;
  }

  #gendhd {
    position: absolute;
    top: 90%;
    right: 0;
    cursor: pointer;
    margin-right: 20px;
    color: #FF5500;
    z-index: 99999;
  }

  #xS_title {
    font-size: 20px;
    height: 60px;
    line-height: 60px;
  }

  #x_list {
    line-height: 30px;
    cursor: pointer;
    text-align: left;
    padding-left: 20px;
    padding-right: 20px;
  }

  #x_list:hover {
    color: #FF5500;
  }

  #gendxs {
    position: absolute;
    top: 90%;
    right: 0;
    cursor: pointer;
    margin-right: 20px;
    color: #FF5500;
    z-index: 99999;
  }

  #zp_counts {
    font-size: 20px;
    font-weight: 500;
    line-height: 100px;
  }

  #zp_counts>span {
    color: #FF5500;
  }

  #zp_coll {
    font-size: 20px;
    font-weight: 500;
    line-height: 100px;
    cursor: pointer;
    color: #FF5500;
  }

  @media screen and (min-width:1680px) and (max-width:1920px) {
    #hSecond {
      width: 1620px;
      height: 100%;
      margin: 0 auto;
      position: relative;
      margin-top: 24px;
    }

    #sConone {
      width: 1620px;
      height: 720px;
      background: rgb(252, 245, 227);
      position: relative;
    }

    #sContow {
      width: 1620px;
      height: 570px;
      background: rgb(235, 247, 255);
      position: relative;
      margin-top: 25px;
    }

    #sConthree {
      width: 1620px;
      height: 550px;
      background: rgb(238, 255, 233);
      position: relative;
      margin-top: 25px;
      margin-bottom: 25px;
    }

    #cThreecon {
      width: 1400px;
      height: 485px;
      margin: 0 auto;
    }

    #cT_left {
      float: left;
      width: 510px;
      height: 420;
      margin-top: 50px;
    }

    #cT_right {
      float: left;
      width: 865px;
      height: 420px;
      margin-left: 25px;
      margin-top: 50px;
      box-shadow: 3px 3px 20px rgba(16, 99, 14, 0.75);
    }

    #cT_title {
      width: 510px;
      ;
      height: 100px;
      line-height: 100px;
      font-size: 20px;
    }

    #cT_cons {
      width: 510px;
      height: 320px;
      box-shadow: 3px 3px 20px rgba(16, 99, 14, 0.75);
      position: relative;
      background-image: url(../assets/img/homepage/bcimg/zxyw.jpg);
      background-size: 100%;
    }

    #cT_img {
      float: left;
      width: 540px;
      height: 420px;
      overflow: hidden;
      cursor: pointer;
    }

    #cT_Xs {
      float: left;
      width: 325px;
      height: 420px;
      background-image: url(../assets/img/homepage/bcimg/shj.jpg);
      background-size: 100%;
    }

    #cT_img>img {
      width: 100%;
      height: 100%;
      transform: scale3d(1, 1, 1);
      transition: opacity 0.35s ease 0s, transform 0.35s ease 0s;
    }

    #cT_img>img:hover {
      transform: scale(1.2);
      -webkit-transform: scale(1.2);
      height: 100%;
      transition: all 1s cubic-bezier(0, 1, 1, 1) 0s;
      -webkit-transition: all 1s cubic-bezier(0, 1, 1, 1) 0s;
    }

    #cMargcon {
      width: 1400px;
      height: 570px;
      margin: 0 auto;
    }

    #cPaddcon {
      width: 1400px;
      height: 545px;
      margin: 0 auto;
    }

    #cP_left {
      float: left;
      width: 545px;
      height: 545px;
      margin-top: 52.5px;
      position: relative;
    }

    #cP_img {
      width: 545px;
      height: 545px;
      margin: 0;
      padding: 0;
      overflow: hidden;
      cursor: pointer;
    }

    #cP_img>img {
      width: 100%;
      height: 100%;
      transform: scale3d(1, 1, 1);
      transition: opacity 0.35s ease 0s, transform 0.35s ease 0s;
    }

    #cP_img>img:hover {
      transform: scale(1.2);
      -webkit-transform: scale(1.2);
      height: 100%;
      transition: all 1s cubic-bezier(0, 1, 1, 1) 0s;
      -webkit-transition: all 1s cubic-bezier(0, 1, 1, 1) 0s;
    }

    #cP_title {
      position: absolute;
      top: 90%;
      right: 0;
      width: 410px;
      height: 110px;
      font-size: 20px;
      line-height: 110px;
      background: #ffffff;
      box-shadow: 3px 3px 20px rgba(188, 123, 8, 0.5);
      cursor: pointer;
      background-image: url(../assets/img/homepage/bcimg/6.jpg);
      background-size: 100%;
    }

    #cP_right {
      float: left;
      width: 815px;
      height: 545px;
      margin-left: 25px;
      margin-top: 50px;
    }

    #cP_top {
      width: 815px;
      height: 175px;
      text-align: left;
    }

    #cP_top>div:nth-child(1) {
      font-size: 20px;
      line-height: 45px;
    }

    #cP_top>div:nth-child(2),
    #cP_top>div:nth-child(3) {
      font-size: 18px;
      line-height: 45px;
    }

    #cP_bottom {
      width: 815px;
      height: 370px;
    }

    #btm_left {
      float: left;
      width: 300px;
      height: 340px;
      position: relative;
    }

    #btm_img {
      width: 300px;
      height: 340px;
      cursor: pointer;
      overflow: hidden;
    }

    #btm_img>img {
      width: 100%;
      height: 100%;
      transform: scale3d(1, 1, 1);
      transition: opacity 0.35s ease 0s, transform 0.35s ease 0s;
    }

    #btm_img>img:hover {
      transform: scale(1.2);
      -webkit-transform: scale(1.2);
      height: 100%;
      transition: all 1s cubic-bezier(0, 1, 1, 1) 0s;
      -webkit-transition: all 1s cubic-bezier(0, 1, 1, 1) 0s;
    }

    #btm_title {
      width: 300px;
      height: 87px;
      font-size: 20px;
      line-height: 87px;
      background: #ffffff;
      box-shadow: 3px 3px 20px rgba(188, 123, 8, 0.5);
      cursor: pointer;
      background-image: url(../assets/img/homepage/bcimg/6.jpg);
      background-size: 100%;
    }

    #btm_right {
      float: left;
      width: 490px;
      height: 370px;
      margin-left: 25px;
      position: relative;
    }

    #rgt_img {
      width: 490px;
      height: 370px;
      overflow: hidden;
      cursor: pointer;
    }

    #rgt_img>img {
      width: 100%;
      height: 100%;
      transform: scale3d(1, 1, 1);
      transition: opacity 0.35s ease 0s, transform 0.35s ease 0s;
    }

    #rgt_img>img:hover {
      transform: scale(1.2);
      -webkit-transform: scale(1.2);
      height: 100%;
      transition: all 1s cubic-bezier(0, 1, 1, 1) 0s;
      -webkit-transition: all 1s cubic-bezier(0, 1, 1, 1) 0s;
    }

    #rgt_title {
      position: absolute;
      top: 88%;
      left: 0;
      width: 400px;
      height: 100px;
      font-size: 20px;
      line-height: 100px;
      background: #ffffff;
      box-shadow: 3px 3px 20px rgba(188, 123, 8, 0.5);
      cursor: pointer;
      background-image: url(../assets/img/homepage/bcimg/6.jpg);
      background-size: 100%;
    }

    #cM_left {
      float: left;
      width: 925px;
      height: 440px;
      margin-top: 65px;
      box-shadow: 3px 3px 20px rgba(15, 106, 130, 0.75);
    }

    #cM_cons {
      width: 100%;
      height: 90%;
    }

    #cM_right {
      float: left;
      width: 433px;
      margin-left: 25px;
      height: 440px;
      margin-top: 65px;
      box-shadow: 3px 3px 20px rgba(15, 106, 130, 0.75);
      background-image: url(../assets/img/homepage/bcimg/hdyy.jpg);
      background-size: 100%;
    }

    #fct {
      position: absolute;
      top: 57%;
      left: 75%;
      width: 300px;
      height: 175px;
    }

    #fct>img {
      width: 100%;
      height: 100%;
    }

    #cT_fc {
      position: absolute;
      top: 60%;
      width: 150px;
      height: 150px;
    }

    #cT_fc>img {
      width: 100%;
      height: 100%;
    }

    #Tow_left {
      float: left;
      width: 700px;
      height: 440px;
      position: relative;
    }

    #Tow_right {
      float: left;
      width: 225px;
      height: 440px;
      position: relative;
      background: #ffffff;
      background-image: url(../assets/img/homepage/bcimg/gczp.jpg);
      background-size: 100%;
    }

    #Tow_right>span {
      font-size: 20px;
    }

    .da-thumbs {
      list-style: none;
      position: relative;
      padding: 0;
      margin: 0;
    }

    .da-thumbs li {
      background: #fff;
      position: relative;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }

    .da-thumbs li a,
    .da-thumbs li a img {
      display: block;
      position: relative;
      width: 100%;
      height: 100%;
    }

    .da-thumbs li a {
      overflow: hidden;
    }

    .da-thumbs li a div {
      position: absolute;
      background: #333;
      background: rgba(75, 75, 75, 0.7);
      width: 100%;
      height: 100%;
    }

    .da-thumbs li a div span:nth-child(1) {
      display: block;
      padding: 10px 0;
      margin: 40px 20px 20px 20px;
      text-transform: uppercase;
      font-weight: normal;
      color: rgba(255, 255, 255, 0.9);
      text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
      border-bottom: 1px solid rgba(255, 255, 255, 0.5);
      /*box-shadow: 0 1px 0 rgba(0,0,0,0.1), 0 -10px 0 rgba(255,255,255,0.3);*/
    }

    .da-thumbs li a div span:nth-child(2) {
      display: block;
      padding: 10px 0;
      margin: 0 20px;
      text-transform: uppercase;
      font-weight: normal;
      color: rgba(255, 255, 255, 0.9);
      text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
      /*border-bottom: 1px solid rgba(255,255,255,0.5);*/
      /*box-shadow: 0 1px 0 rgba(0,0,0,0.1), 0 -10px 0 rgba(255,255,255,0.3);*/
    }

    #da-thumbs_nav1 {
      float: left;
      width: 350px;
      height: 440px;
    }

    #da-thumbs_nav2 {
      float: left;
      width: 350px;
      height: 440px;
    }

    #cM_title {
      font-size: 20px;
      height: 60px;
      line-height: 60px;
    }

    #zp_title {
      font-size: 20px;
      height: 140px;
      line-height: 140px;
    }

    #gend {
      position: absolute;
      line-height: 40px;
      text-align: right;
      margin-right: 20px;
      color: #FF5500;
      cursor: pointer;
      right: 4%;
      top: 84%;
      font-size: 18px;
    }

    #zxxw {
      text-align: left;
      line-height: 50px;
      cursor: pointer;
      font-size: 18px;
      position: relative;
      z-index: 999;
    }

    #zxxw:hover {
      color: #FF5500;
    }

    #hd_left {
      float: left;
      margin-left: 20px;
      font-size: 17px;
    }

    #hd_right {
      float: right;
      margin-right: 20px;
      font-size: 18px;
    }

    #hdlist {
      line-height: 35px;
      cursor: pointer;
    }

    #hdlist:hover {
      color: #FF5500;
    }

    #gendhd {
      position: absolute;
      top: 100%;
      right: 5%;
      cursor: pointer;
      margin-right: 20px;
      color: #FF5500;
      z-index: 99999;
      font-size: 18px;
    }

    #xS_title {
      font-size: 20px;
      height: 60px;
      line-height: 60px;
    }

    #x_list {
      line-height: 40px;
      cursor: pointer;
      text-align: left;
      padding-left: 20px;
      padding-right: 20px;
      font-size: 18px;
    }

    #x_list:hover {
      color: #FF5500;
    }

    #gendxs {
      position: absolute;
      top: 89%;
      right: 5%;
      cursor: pointer;
      margin-right: 20px;
      color: #FF5500;
      z-index: 99999;
      font-size: 18px;
    }

    #zp_counts {
      font-size: 20px;
      font-weight: 500;
      line-height: 150px;
    }

    #zp_counts>span {
      color: #FF5500;
    }

    #zp_coll {
      font-size: 20px;
      font-weight: 500;
      line-height: 150px;
      cursor: pointer;
      color: #FF5500;
    }
  }

  .notices {
    position: fixed;
    top: 25%;
    left: 2%;
    width: 200px;
    height: 80px;
    z-index: 999;
    border-radius: 10px;
    background: #FFFFFF;
    /* alternate：动画先正常运行再反方向运行，并持续交替运行 */
    animation: horizontal 20s linear 0s infinite alternate, vertical 20s linear 0s infinite alternate;
    -webkit-animation: horizontal 20s linear 0s infinite alternate, vertical 20s linear 0s infinite alternate;
    -ms-animation: horizontal 20s linear 0s infinite alternate, vertical 20s linear 0s infinite alternate;
    -moz-animation:  horizontal 20s linear 0s infinite alternate, vertical 20s linear 0s infinite alternate;
  }

  .clear {
    clear: both;
  }

  @media (min-width:1280px) {
    @keyframes horizontal {
      0% {
        left: 0;
      }

      100% {
        /* 运动最大距离为盒子长度减去球的长度 */
        left: calc(1700px - 200px);
      }
    }

    @keyframes vertical {
      0% {
        top: 0;
      }

      100% {
        /* 运动最大距离为盒子高度减去球的高度 */
        top: calc(800px - 80px);
      }
    }
  }

  @media (min-width:1360px) {
    @keyframes horizontal {
      0% {
        left: 0;
      }

      100% {
        /* 运动最大距离为盒子长度减去球的长度 */
        left: calc(1360px - 200px);
      }
    }

    @keyframes vertical {
      0% {
        top: 0;
      }

      100% {
        /* 运动最大距离为盒子高度减去球的高度 */
        top: calc(700px - 80px);
      }
    }
  }

  @media (min-width:1400px) {
    @keyframes horizontal {
      0% {
        left: 0;
      }

      100% {
        /* 运动最大距离为盒子长度减去球的长度 */
        left: calc(1400px - 200px);
      }
    }

    @keyframes vertical {
      0% {
        top: 0;
      }

      100% {
        /* 运动最大距离为盒子高度减去球的高度 */
        top: calc(900px - 80px);
      }
    }
  }

  @media (min-width:1600px) {
    @keyframes horizontal {
      0% {
        left: 0;
      }

      100% {
        /* 运动最大距离为盒子长度减去球的长度 */
        left: calc(1600px - 200px);
      }
    }

    @keyframes vertical {
      0% {
        top: 0;
      }

      100% {
        /* 运动最大距离为盒子高度减去球的高度 */
        top: calc(1000px - 80px);
      }
    }
  }

  @media (min-width:1700px) {
    @keyframes horizontal {
      0% {
        left: 0;
      }

      100% {
        /* 运动最大距离为盒子长度减去球的长度 */
        left: calc(1700px - 200px);
      }
    }

    @keyframes vertical {
      0% {
        top: 0;
      }

      100% {
        /* 运动最大距离为盒子高度减去球的高度 */
        top: calc(1000px - 80px);
      }
    }
  }

  @media (min-width:1920px) {
    @keyframes horizontal {
      0% {
        left: 0;
      }

      100% {
        /* 运动最大距离为盒子长度减去球的长度 */
        left: calc(1920px - 200px);
      }
    }

    @keyframes vertical {
      0% {
        top: 0;
      }

      100% {
        /* 运动最大距离为盒子高度减去球的高度 */
        top: calc(1000px - 80px);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Homepage.vue